<template>
  <pict image-class="w-full m:w-auto" :default="imageProps.default" :sources="imageProps.sources" :alt="$t('alt')" />
</template>

<script>
import Pict from "@/shared/pict"

import imageL from "./images/faq-image.png"
import imageL2x from "./images/faq-image@2x.png"
import imageS from "./images/faq-image_s.png"
import imageS2x from "./images/faq-image_s@2x.png"

export default {
  name: "FaqImage",
  components: {
    Pict
  },
  computed: {
    imageProps() {
      return {
        default: {
          src: imageL,
          srcset: {
            "2x": imageL2x
          }
        },
        sources: [
          {
            media: "s",
            src: imageS,
            srcset: {
              "2x": imageS2x
            }
          }
        ]
      }
    }
  },
  i18n: {
    messages: {
      en: {
        alt: "A person with long dark hair and wearing blue glasses and a yellow shirt striped with blue taps on a blue square on their mobile device. Another person with long dark hair and fringe, wearing a blue shirt with white dots receives a message on their yellow mobile device."
      },
      de: {
        alt: "Eine Person mit langen schwarzen Haaren, einer braunen Brille und einer gelb-blau gestreiften Bluse tippt auf ein blaues Quadrat in ihrem Smartphone. Neben ihr empfängt eine Person mit langen schwarzen Haaren und einer blauen Kurzarmbluse eine Nachricht auf dem Smartphone."
      }
    }
  }
}
</script>
